import axios from 'axios'
import * as vars from './vars';

export function getCollege(ipedsid) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/college/FetchCollege',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: {
            ipedsid: ipedsid
        }
    })
}

export function getCollegeReviews(ipedsid) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/college/GetCollegeReviews',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: {ipedsid: ipedsid}
    })
}

export function reviewCollege(review, ipedsid, jwt) {
    const data = review
    data['ipedsid'] = ipedsid
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/colleges/SubmitCollegeReview',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

export function getCollegeImages(ipedsid) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/college/GetProfessionalCollegePhotos',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: {
            ipedsid: ipedsid
        }
    })
}

export function getCollegeHighlights(ipedsid, type) {
    let input = {ipedsid: ipedsid}

    if (type) {
        input['type'] = type
    }

    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/college/GetUserGeneratedCollegeContent',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: input
    })
}

export function getFavorites(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/colleges/GetFavoriteColleges',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function removeFavorite(ipedsid, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/colleges/RemoveFavoriteCollege',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            ipedsid: ipedsid,
        }
    })
}

export function favorite(ipedsid, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/colleges/AddFavoriteCollege',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            ipedsid: ipedsid,
        }
    })
}

export function getDiscoveryImages(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/discovery/DiscoverImages',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function getDiscoveryVideos(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/discovery/DiscoverVideos',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

//   Params: userId, query
export function searchColleges(query, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/discovery/DiscoverColleges',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {query: query}
    })
}

export function getRecommendedColleges(ipedsid, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/colleges/GetRecommendedColleges',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            ipedsid: ipedsid
        }
    })
}

export function getDisplayColleges(getDisplayCollegesRequest) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/colleges/GetDisplayColleges',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: getDisplayCollegesRequest
    })
}